import {createSlice} from '@reduxjs/toolkit'

const initialState = {
  chartVariables: {
    healthKey: null,
    minRisk: 0,
    maxRisk: 100,
    stateCode: null,
    stateCountyCode: null
  },
  chartNationData: {
    chartData: null,
    loadingChart: false,
    errorLoadingChart: null
  },
  chartStateData: {
    chartData: null,
    loadingChart: false,
    errorLoadingChart: null
  },
  chartCountyData: {
    chartData: null,
    loadingChart: false,
    errorLoadingChart: null
  }
}

const longitudinalRiskChartSlice = createSlice({
  name: 'longitudinalRiskChart',
  initialState,
  reducers: {
    setChartVariables: (state, action) => {
      state.chartVariables = action.payload
    },
    setChartNationData: (state, action) => {
      state.chartNationData.chartData = action.payload
    },
    setLoadingChartNation: (state, action) => {
      state.chartNationData.loadingChart = action.payload
    },
    setErrorLoadingChartNation: (state, action) => {
      state.chartNationData.errorLoadingChart = action.payload
    },
    setChartStateData: (state, action) => {
      state.chartStateData.chartData = action.payload
    },
    setLoadingChartState: (state, action) => {
      state.chartStateData.loadingChart = action.payload
    },
    setErrorLoadingChartState: (state, action) => {
      state.chartStateData.errorLoadingChart = action.payload
    },
    setChartCountyData: (state, action) => {
      state.chartCountyData.chartData = action.payload
    },
    setLoadingChartCounty: (state, action) => {
      state.chartCountyData.loadingChart = action.payload
    },
    setErrorLoadingChartCounty: (state, action) => {
      state.chartCountyData.errorLoadingChart = action.payload
    },
    resetChartVariables: (state) => {
      state.chartVariables = initialState.chartVariables
    },
    clearChartData: (state) => {
      state.chartNationData = initialState.chartNationData
      state.chartStateData = initialState.chartStateData
      state.chartCountyData = initialState.chartCountyData
    }
  }
})

export const {
  setChartVariables,
  setChartNationData,
  setLoadingChartNation,
  setErrorLoadingChartNation,
  setChartStateData,
  setLoadingChartState,
  setErrorLoadingChartState,
  setChartCountyData,
  setLoadingChartCounty,
  setErrorLoadingChartCounty,
  resetChartVariables,
  clearChartData
} = longitudinalRiskChartSlice.actions

export default longitudinalRiskChartSlice.reducer

// Selectors
export const selectChartVariables = (state) => state.longitudinalRiskChart.chartVariables
export const selectChartNationData = (state) => state.longitudinalRiskChart.chartNationData
export const selectChartStateData = (state) => state.longitudinalRiskChart.chartStateData
export const selectChartCountyData = (state) => state.longitudinalRiskChart.chartCountyData
